import { render, staticRenderFns } from "./addnotice.vue?vue&type=template&id=cfa0d2d0&scoped=true&"
import script from "./addnotice.vue?vue&type=script&lang=js&"
export * from "./addnotice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfa0d2d0",
  null
  
)

export default component.exports